import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IUser } from '@ebb-v2/ebb-integration';
import { observable, Observable, of } from 'rxjs';
import { flatMap, map, mergeMap } from 'rxjs/operators';

import { AuthenticationService, ContactApiService, CONTRACTOR_TYPE } from './data-services/index';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    public currentUser: IUser = {} as IUser;
    
    constructor(
        private router: Router,
        private apiContact: ContactApiService,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const url: string = state.url;
        if(route.queryParams.dashboard && 
            (route.queryParams.dashboard.toLowerCase() === 'contractor' ||
            route.queryParams.dashboard.toLowerCase() === 'contractor?nonce='))
        {
            localStorage.setItem("dashboard", CONTRACTOR_TYPE);
        }
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            return true;
        } else {
            return this.authenticationService.getCurrentAuthentication().pipe(mergeMap( user =>{
                if(user && user.isAuthenticated && user.email) {
                    return this.authenticationService.getUserStatus(user.email,"").pipe(mergeMap( info => {
                        if(!info.isVerified && !info.isEbbLegacy && !info.hasB2c) {
                            // has not complete registration so redirect to registration page with the return url
                            this.authenticationService.redirectUrl = url;
                            window.window.location.href = this.authenticationService.uriSpaRegister;
                            return of(false);
                        }
                        else {
                            return this.setCurrentUser(user.email); 
                        }
                    }));
                } 
                else if(user.isAdmin && !user.email)
                {
                    // not logged in so redirect to login page with the return url
                    this.authenticationService.redirectUrl = url;
                    this.router.navigate(['/impersonate']);
                    return of(false);
                }
                else{
                    // not logged in so redirect to login page with the return url
                    this.authenticationService.redirectUrl = url;
                    this.router.navigate(['/login']);
                    return of(false);
                }
              }));
        }
        
    }
        
    private setCurrentUser(userEmail: string): Observable<boolean> {
        return this.apiContact
        .getContact()
        .pipe( map(
            data => { 
                if (data) {
                    this.currentUser.id = data.id;
                    this.currentUser.fullName = data.fullName;
                    this.currentUser.needsProfileUpdate = !data.firstName || !data.lastName;
                    this.currentUser.email = data.emailAddress1;
                    this.currentUser.isHomeowner = data.isHomeowner;
                    this.currentUser.isContractor = data.isContractor;
                    this.currentUser.isEngineer = data.isEngineer;
                    this.currentUser.isInspector = data.isInspector;
                    this.currentUser.mode = this.authenticationService.defaultUserMode(this.currentUser);
                    this.authenticationService.setCurrentUserValue(this.currentUser);
                    return true;
                } else {
                    return false;
                }
            }
        ));
    }
}